// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

//see node_modules/history/createBrowserHistory.js
import { createBrowserHistory } from 'history';
import { createMemoryHistory } from 'history';

export const browserHistory = createBrowserHistory();
export const memoryHistory = createMemoryHistory();
